











































































import { Component, Vue, Watch, Prop, Emit } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import BackofficeAutorizacaoStore from '@/components/Backoffice/Store/BackofficeAutorizacaoStore'
import SolicitacaoPendenciaStore from '@/components/SolicitacaoPendencia/Store/SolicitacaoPendenciaStore'
import { timeoutDefault } from '@/utils/common'
import { SolicitacaoAcoesBackofficeEnum } from '@/types/_'
import { Autorizacao } from '@/types/core'
import EventBus from '@/plugins/EventBus'

@Component
export default class ComponentModalConfirmarAnalisePosCotacaoBtn extends Vue {
  @Prop({ required: true, default: '' }) modalParent: string
  @Prop({ required: true, default: 'Informe o texto' }) textoBtn: string
  @Prop({ required: false, default: {} }) refParent: any

  autorizacaoImp: Autorizacao.IAutorizacao = new Autorizacao.Autorizacao()
  $refs!: {
    form: any,
  }

  formRules: any = {
    valid: true,
    comentarios: [
      v => !!v || 'O campo Comentários é obrigatório.',
    ],
  }

  modal: boolean = false
  loadSave: boolean = false
  loadOpenModal: boolean = false
  loadCloseToolbar: boolean = false
  loadCloseCancelar: boolean = false

  get loadingCloseCancelar() {
    return this.loadCloseCancelar
  }

  set loadingCloseCancelar(value: boolean) {
    this.loadCloseCancelar = value
  }

  get loadingCloseToolbar() {
    return this.loadCloseToolbar
  }

  set loadingCloseToolbar(value: boolean) {
    this.loadCloseToolbar = value
  }

  get loadingSave() {
    return this.loadSave
  }

  set loadingSave(value: boolean) {
    this.loadSave = value
  }

  get loadingOpenModal() {
    return this.loadOpenModal
  }

  set loadingOpenModal(value: boolean) {
    this.loadOpenModal = value
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getBackofficeAutorizacaoStore() {
    return getModule(BackofficeAutorizacaoStore, this.$store)
  }

  get getPendenciaStore() {
    return getModule(SolicitacaoPendenciaStore, this.$store)
  }

  get getComentarios() {
    const { comentarios } = this.getBackofficeGlobalStore.solicitacao.cotacaoOperadorasExtraGrupo!
    return comentarios || ''
  }

  set getComentarios(value: string) {
    this.getBackofficeGlobalStore.setComentarios(value)
  }

  async closeToolbar() {
    this.loadingCloseToolbar = true
    await timeoutDefault()
    this.modal = false
    this.getBackofficeGlobalStore.clearComentarios()
    this.loadingCloseToolbar = false
  }

  async closeCancelar() {
    this.loadingCloseCancelar = true
    await timeoutDefault()
    this.modal = false
    this.getBackofficeGlobalStore.clearComentarios()
    this.loadingCloseCancelar = false
  }

  async showModal() {
    this.loadingOpenModal = true
    const isValidProtocoloOperadora = this.analisePosCotacao().validation.protocoloOperadoraValid
    this.modal = isValidProtocoloOperadora
    await timeoutDefault()
    this.loadingOpenModal = false
  }

  async confirmar() {
    this.loadingSave = true

    if (this.analisePosCotacao().pendencia.status) {
      this.analisePosCotacao().pendencia.emit()
      return
    }

    if (this.analisePosCotacao().validation.formValid) {
      const response = await this.analisePosCotacao().post.send(this.analisePosCotacao().post.params())
      if (response.success) {
        EventBus.$emit('setSnackbar', { show: true, text: 'Solicitacao enviada para aguardando cotação com sucesso!', icon: 'done', color: '#2E7D32' })
        await this.closeModal()
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: response.message || 'Houve um problema na solicitação..', icon: 'warning', color: '#C62828' })
      }
    }

    this.loadingSave = false
  }

  async send(params: any) {
    const response = await this.autorizacaoImp.enviarGuias(params)
    return response
  }

  analisePosCotacao() {
    return {
      pendencia: {
        status: this.getPendenciaStore.pendencia.mensagens.length > 0,
        emit: this.emitPendencia,
      },
      validation: {
        formValid: this.$refs.form.validate(),
        protocoloOperadoraValid: this.isValidProtocoloOperadoraForm(),
      },
      post: {
        params: this.params,
        send: this.autorizacaoImp.enviarGuias,
      },
    }
  }

  params() {
    const params: any = {
      acao: SolicitacaoAcoesBackofficeEnum.AutorizacaoFazAnalisePosCotacao,
      body: {
        solicitacaoId: this.getBackofficeGlobalStore.solicitacao.id,
        comentarios: this.getComentarios,
      },
    }

    if (this.isValidProtocoloOperadoraForm()) {
      params.body.protocoloOPME = this.getBackofficeGlobalStore.solicitacao.protocoloOPME
      params.body.protocoloOperadora = this.getBackofficeGlobalStore.solicitacao.protocoloOperadora
      params.body.operadoraSenhaProvisoria = this.getBackofficeGlobalStore.solicitacao.operadoraSenhaProvisoria
    }

    if (this.isValidGrupoOpmeDaSolicitacao()) {
      params.body.grupoOpmes = this.grupoOpmeDaSolicitacao()
    }
    return params
  }

  grupoOpmeDaSolicitacao() {
    const { grupoOpmeDaSolicitacao } = this.getBackofficeGlobalStore.solicitacao
    return grupoOpmeDaSolicitacao.reduce((acc: any, obj: any) => {
      const opmes = obj.opmes.reduce((y: any, x: any) => {
        const opme: any = {}
        if (x.opmeId) opme.opmeId = x.opmeId
        if (x.tipo) opme.tipo = x.tipo
        if (x.codigoHospital) opme.codigoHospital = x.codigoHospital
        if (x.fazCotacao) opme.fazCotacao = x.fazCotacao
        if (x.necessitaDeProfissionalAdicional) opme.necessitaDeProfissionalAdicional = x.necessitaDeProfissionalAdicional
        if (x.valorUnitario) opme.valorUnitario = x.valorUnitario

        y.push({ ...opme })
        return y
      }, [])

      acc.push({ id: obj.id, opmes })

      return acc
    }, [])
  }

  isValidProtocoloOperadoraForm() {
    let isValid: boolean = true
    const { autorizacaoDeveInformarProtocoloDaOperadora } = this.getBackofficeGlobalStore.solicitacao
    if (autorizacaoDeveInformarProtocoloDaOperadora) {
      const isValidProtocoloOperadora = this.refParent.$refs.protocoloOperadoraForm.validate()
      if (!isValidProtocoloOperadora) isValid = false
    }

    return isValid
  }

  isValidGrupoOpmeDaSolicitacao = () => {
    const { grupoOpmeDaSolicitacao } = this.getBackofficeGlobalStore.solicitacao
    return grupoOpmeDaSolicitacao.length > 0
  }

  async closeModal() {
    let solicitacaoId = this.getBackofficeGlobalStore.solicitacao.id
    await this.autorizacaoImp.desbloquearSolicitacao(this.getBackofficeGlobalStore.solicitacao.id)
    await this.getBackofficeAutorizacaoStore.loadAgendamentosMedicoSearch(solicitacaoId)
    solicitacaoId = ''
    this.getBackofficeGlobalStore.closeModalAutorizarProcesso()
    this.getBackofficeAutorizacaoStore.deleteSolicitacao(this.getBackofficeGlobalStore.solicitacao.id)
    this.modal = false
    this.getBackofficeGlobalStore.setModal({ name: this.modalParent, value: false })
  }

  @Emit('showModalPendencia')
  emitPendencia() {}

  @Watch('modal')
  onModalChange() {
    this.$refs.form.resetValidation()
  }
}
